<form [formGroup]="qfStore.clientLookupForm">
  <div class="grid gap-8">
    <bolt-radio-group
      formControlName="lookupType"
      bounded
      label="Search by:"
      required
      (input)="resetClientLookupState()"
    >
      <bolt-radio [value]="clientLookupTypes.POLICY_NUMBER">{{
        clientLookupTypes.POLICY_NUMBER | sentencecase
      }}</bolt-radio>
      <bolt-radio [value]="clientLookupTypes.SUBMISSION_NUMBER">{{
        clientLookupTypes.SUBMISSION_NUMBER | sentencecase
      }}</bolt-radio>
    </bolt-radio-group>

    <bolt-textfield
      (input)="resetClientLookupState()"
      (keyDown.enter)="handleClientLookupSearch()"
      [error]="formValidationErrors()['lookupValue']"
      [indicator]="searchIndicator"
      formControlName="lookupValue"
      label="Number"
      required
      [invalid]="qfStore.isFieldInvalid('lookupValue', 'editable')"
    ></bolt-textfield>

    <!-- Navigation -->
    <bolt-button
      (click)="handleClientLookupSearch()"
      (keyDown.enter)="handleClientLookupSearch()"
      [disabled]="apigeeIsLoading()"
      class="w-full"
      color="{{ qfStore.isLookupSuccessful() ? 'secondary' : '' }}"
      type="{{ qfStore.isLookupSuccessful() ? 'primary' : 'solid' }}"
      >{{ qfStore.isLookupSuccessful() ? 'Continue' : 'Search' }}</bolt-button
    >

    <bolt-note heading="">
      <b>For clients without a Nationwide homeowners policy</b>
      <br />
      Please call {{ productInfo.phone }} to get a quote.
    </bolt-note>
  </div>
</form>
